<template>
  <div :id="editTableName" style="height: 100%;">
    <tool-bar-action
      :show-add-btn="showAddBtn"
      :default-add-btn-text="defaultAddBtnText"
      :show-edit-btn="showEditBtn"
      :show-batch-del-btn="showBatchDelBtn"
      :default-search-box="defaultSearchBox"
      :default-search-btn="defaultSearchBtn"
      :search-box-placeholder="searchBoxPlaceholder"
      :view-text="viewText"
      :default-batch-del-text="defaultBatchDelText"
      :change-view-mode="changeViewMode"
      :delete-item="deleteItem"
      :batch-delete-confirm="batchDeleteConfirm"
      :on-search-btn-click="onSearchBtnClick"
      :add-new-item="addNewItem"
    >
      <template slot="toolbarSearch">
        <slot name="toolbarSearch"></slot>
      </template>
      <template slot="toolBarAction">
        <slot name="toolBarAction"></slot>
      </template>
    </tool-bar-action>
    <div class="table-tool-header-wrapper">
      <slot name="tableHeader"></slot>
    </div>
    <div class="dxy-table-wrapper">
      <div class="dxy-table-table-caption">
        <slot name="tableCaption"></slot>
      </div>
      <div class="dxy-table-header-wrapper" ref="header"  style="overflow: hidden" @mousewheel="handleMouseWheel">
        <table class="dxy-table" >
          <thead class="dxy-table-header">
          <tr class="dxy-table-title">
            <template v-for="(column,index) in insideColumns">
              <th class="dxy-table-border-th"
                  :key="index"
                  v-if="showColumn(column)">
                <div :style="{width:column.width + 'px' }">
                  <template v-if="column.type === 'selection'">
                    <label style="align-content: center"><input v-model="selectAll" type="checkbox" @click.exact="toggleAllSelect()"><i>✓</i></label><br>
                  </template>
                  <div v-else>
                    <!--一级标题-->
                    <div style="line-height: 32px;">
                      <p class="h-p0" style="display: inline-block">{{column.title.split(' ')[0]}}</p>

                      <span :class="[prefixCls + '-sort']" style="margin-left: 2px;" v-if="column.sortable && editable">
                <i class="ivu-icon ivu-icon-md-arrow-dropup" :class="{on: getColumn(index)._sortType === 'asc'}" @click="handleSort(getColumn(index), 'asc')"></i>
                <i class="ivu-icon ivu-icon-md-arrow-dropdown" :class="{on: getColumn(index)._sortType === 'desc'}" @click="handleSort(getColumn(index), 'desc')"></i>
                </span>
                      <Poptip
                        style="margin-left: 2px;"
                        v-if="isPopperShow(column)"
                        v-model="getColumn(index)._filterVisible"
                        placement="bottom"
                        popper-class="ivu-table-popper"
                        transfer
                        @on-popper-hide="handleFilterHide(index)">
                                <span v-if="editable" :class="[prefixCls + '-filter']">
                                    <i class="ivu-icon ivu-icon-ios-funnel" :class="{on: getColumn(index)._isFiltered}"></i>
                                </span>

                        <div slot="content" :class="[prefixCls + '-filter-list']" v-if="getColumn(index)._filterMultiple">
                          <div :class="[prefixCls + '-filter-list-item']">
                            <checkbox-group v-model="getColumn(index)._filterChecked">
                              <checkbox v-for="(item, index1) in column.filters" :key="index1" :label="item.value">{{ item.label }}</checkbox>
                            </checkbox-group>
                          </div>
                          <div :class="[prefixCls + '-filter-footer']">
                            <i-button type="text" size="small" :disabled="!getColumn(index)._filterChecked.length" @click.native="handleFilter(index)">筛选</i-button>
                            <i-button type="text" size="small" @click.native="handleReset(index)">重置</i-button>
                          </div>
                        </div>
                        <div slot="content" :class="[prefixCls + '-filter-list']" v-else>
                          <ul :class="[prefixCls + '-filter-list-single']">
                            <li
                              :class="itemAllClasses(getColumn(index))"
                              @click="handleReset(index)">全部</li>
                            <li
                              v-for="(item, itemIndex) in column.filters"
                              :key="itemIndex"
                              :class="itemClasses(getColumn(index), item)"
                              @click="handleSelect(index, item.value)">{{ item.label }}</li>
                          </ul>
                        </div>
                      </Poptip>
                    </div>
                    <!--二级标题-->
                    <div v-if="column.title.split(' ').length === 2" class="h-p1" >{{column.title.split(' ')[1]}}</div>
                  </div>
                </div>
              </th>
            </template>
          </tr>
          </thead>
        </table>
      </div>
      <div class="dxy-table-body-wrapper" :style="{ height: height, maxHeight: maxHeight, overflowX: 'scroll' }" ref="body" @scroll="handleBodyScroll">
        <table class="dxy-table">
          <tbody>
          <tr v-for="(row,rindex) in insideData" :key="row.$rowKeyIndex" class="dxy-table-border-td">
            <template v-for="(column,cindex) in insideColumns">
              <td  v-if="showColumn(column)"
                   class="dxy-table-border-td" :key="row.$rowKeyIndex + cindex"
                   @contextmenu="$ContextMenu($event,$root, 'editTableMenuContext',  {row: row, column: column}, true)"
              >
                <div v-if="column.type === 'selection'" style="text-align: center" :style="{width:column.width+ 'px' }">
                  <template>
                    <label><input v-model="checkedIndex[rindex]" @click="toggleSelect(rindex)" type="checkbox"><i>✓</i></label><br>
                  </template>
                </div>
                <div v-else class="table-body-cell" :style="{width:column.width+ 'px',border: cellValidateObj[row.$rowKeyIndex + '_' + column.key] ? '1px solid red' : 'none' }">
                  <div v-if="!(!enableCellValidate || !cellValidateObj[row.$rowKeyIndex + '_' + column.key])" class="dw-tooltip-popper">
                    <div class="dw-tooltip-content">
                      <div class="dw-tooltip-arrow"></div>
                      <div  class="dw-tooltip-text">{{column.$validateMessage ? column.$validateMessage : '规则验证失败'}}</div>
                    </div>
                  </div>
                  <render-cell v-if="column.render" :row="row" :column="column" :cindex="cindex" />
                    <edit-div-cell v-else
                                   :editable="editable"
                                   :cell-editable="checkCanEditable(row, column)"
                                   :clipboardCopy="clipboardCopy"
                                   @on-cell-content-copy="onCellContentCopy($event)"
                                   v-model="row[column.key]"
                                   @on-blur="onValidateRule(row, column)"
                    >
                    </edit-div-cell>
                </div>
              </td>
            </template>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="full-width no-data-info"
           v-if="editable && insideData.length === 0"
      >暂无数据</div>
      <div v-if=" pageCount > 0" style="padding:10px 5px">
        <Page :total="totalCount"
              :current="currentPage"
              :show-sizer="showSizer"
              :show-elevator="showElevator"
              :pageSize = "pageSize"
              :page-size-opts = "pageSizeOpts"
              @on-change="changePage($event)"
              @on-page-size-change="changePageSize($event)"
              :show-total="showTotal"
        >
        </Page>
      </div>
      <Spin v-if="loading" size="large" fix>
        <Icon type="ios-loading"  size=18 class="edit-table-spin-icon-load"></Icon>
        <div>数据加载中...</div>
      </Spin>
      <div class="change-cover" id="cover">
          <div id="close">
            <div class="loading4">
              <div class="three1"></div>
              <div class="three2"></div>
              <div class="three3"></div>
            </div>
            <div style="margin: 50px auto;text-align: center">
              表格模式转换中，请稍等...
            </div>
          </div>
      </div>
      <div v-if="enableContextMenu">
        <context-menu tag="editTableMenuContext" :border="false" :list="menuList ? menuList: []"
                      :underline="contextMenuOption.underline"
                      :offset="{x: -200, y: -80 }"
                      :userCustomerIcon="contextMenuOption.userCustomerIcon"
                      :arrow="contextMenuOption.arrow"
                      @context-menu-click="onContextMenuClick($event)"
        >
        </context-menu>
      </div>
    </div>
  </div>
</template>
<script>
import handleBtns from './../common/handle-btns'
import { compareArr, delArrObject } from './../../utils/assist'
import EditDivCell from '../cell/edit-div-cell'
import RenderCell from './render-cell'
import ToolBarAction from './tool-bar-action'
export default {
  name: 'edit-table',
  components: { ToolBarAction, EditDivCell, RenderCell },
  props: {
    // 是否开启单元格右击菜单
    enableContextMenu: { type: Boolean, default: false },
    menuList: { type: Array, default () { return [] } },
    enableCellValidate: { type: Boolean, default: false },
    cellValidateRule: {
      type: Function,
      default () {
        return true
      }
    },
    contextMenuOption: {
      type: Object,
      default () {
        return {
          underline: true,
          arrow: true,
          userCustomerIcon: false
        }
      }
    },
    // 是否开启双击单元格复制内容到剪切板
    clipboardCopy: { type: Boolean, default: false },
    // 能作为行唯一标识的属性名
    rowIdentifyKey: { type: String, default: 'id' },
    // 是否支持跨页选中
    supportSpreadPageSelect: { type: Boolean, default: false },
    defaultSearchKey: {
      type: String,
      default: ''
    },
    totalCount: {
      type: Number,
      default: 0
    },
    showTotal: {
      type: Boolean,
      default: true
    },
    showSizer: {
      type: Boolean,
      default: true
    },
    pageSizeOpts: {
      type: Array,
      default () { return [10, 30, 50, 100] }
    },
    showElevator: {
      type: Boolean,
      default: true
    },
    /** 函数回调 **/
    queryDataCallBack: {
      type: Function,
      default () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Array,
      default () {
        return []
      }
    },
    columns: {
      type: Array,
      default () {
        return []
      }
    },
    defaultBtnPermission: {
      type: Function,
      default () {
        return () => {
          return true
        }
      }
    },
    /** *低优先级配置项**/
    showAddBtn: {
      type: Boolean,
      default: true
    },
    defaultAddBtnText: {
      default: '新增'
    },
    defaultValue: {
      type: Object,
      default: () => {}
    },
    showEditBtn: {
      type: Boolean,
      default: true
    },
    defaultEditViewText: {
      default: '编辑'
    },
    defaultEditSaveText: {
      default: '保存'
    },
    showBatchDelBtn: {
      type: Boolean,
      default: true
    },
    defaultBatchDelText: {
      type: String,
      default: '删除'
    },
    defaultSearchBox: {
      type: Boolean,
      default: false
    },
    defaultSearchBtn: {
      type: Boolean,
      default: false
    },
    searchBoxPlaceholder: {
      default: '输入关键字搜索'
    },
    height: {
      type: [String, Number],
      default: '100%'
    },
    maxHeight: {
      type: [String, Number],
      default: '100%'
    },
    beforeSaveCallBack: {
      type: Function,
      default () {
        return () => true
      }
    },
    saveCallBack: {
      type: Function,
      default () {
        return () => true
      }
    }
  },
  data () {
    return {
      leftCoverMargin: 0,
      topCoverMargin: 0,
      coverHeight: 0,
      editTableName: 'editTable_',
      prefixCls: 'ivu-table',
      insideData: [],
      insideColumns: [],
      selectAll: false,
      checkedIndex: [],
      checkedItems: [],
      changeItems: [],
      addItems: [],
      editable: true,
      viewText: '编辑',
      pageSize: 20,
      currentPage: 1,
      batchDeleteConfirm: false,
      searchKey: '',
      cellValidateObj: {}
    }
  },
  methods: {
    copyAndWriteData (fromCopyData, toWriteData) {
      if (fromCopyData.$rowKeyIndex === toWriteData.$rowKeyIndex) {
        return
      }
      let currentTime = new Date().getTime()
      let cloneFromCopyData = JSON.parse(JSON.stringify(fromCopyData))
      let cloneToWriteData = JSON.parse(JSON.stringify(toWriteData))
      let copySuccess = false
      if (cloneFromCopyData && cloneToWriteData) {
        if (cloneToWriteData) {
          let existIndex = this.insideData.findIndex((item) => item.$rowKeyIndex === cloneToWriteData.$rowKeyIndex)
          if (existIndex !== -1) {
            let existData = this.insideData[existIndex]
            // 如果复制的目标是新增行, 则只需将已存在的新增行三个属性覆盖
            if (cloneToWriteData.$actionType === 'add') {
              let newAddObject = Object.assign(cloneFromCopyData, JSON.parse(JSON.stringify(existData)))
              // 如果是新增需要删除id 属性
              if (newAddObject.hasOwnProperty('id')) {
                delete newAddObject.id
              }
              newAddObject.$rowKeyIndex = currentTime + '_0'
              this.insideData.splice(existIndex, 1, newAddObject)
              copySuccess = true
            } else if (cloneToWriteData.$actionType === 'update') {
              let retainProperty = { $actionType: 'update', id: cloneToWriteData.id, $rowKeyIndex: currentTime + '_1' }
              let updateObject = Object.assign(cloneFromCopyData, retainProperty)
              this.insideData.splice(existIndex, 1, updateObject)
              copySuccess = true
            }
          } else {
            console.error('edit table copy write fail, can not find writer data in inside table data ')
          }
        }
      }
      return copySuccess
    },
    onValidateRule (rowData, column) {
      // 如果不启用单元格验证，则直接返回
      if (!this.enableCellValidate) {
        return
      }
      // 如果列明确的cellValidate = true，则不启用
      if (!column.cellValidate) {
        return
      }
      // 编辑模式时进行规则验证
      if (!this.editable) {
        let finalUseValidateFunc = this.cellValidateRule
        // 如果某列有自己的验证函数则会优先使用，否则使用通用的验证函数
        if (column.hasOwnProperty('cellValidateRule')) {
          finalUseValidateFunc = column.cellValidateRule
        }
        let validateResult = {
          valid: true,
          message: '验证成功'
        }
        if (finalUseValidateFunc) {
          validateResult = finalUseValidateFunc(rowData, column)
        }
        let cellName = rowData.$rowKeyIndex + '_' + column.key
        if (!validateResult.valid) {
          this.$set(this.cellValidateObj, cellName, true)
          this.$set(column, '$validateMessage', validateResult.message)
        } else {
          if (this.cellValidateObj.hasOwnProperty(cellName)) {
            this.$set(this.cellValidateObj, cellName, false)
          }
        }
      }
    },
    handleBodyScroll (event) {
      this.$refs.header.scrollLeft = event.target.scrollLeft
    },
    handleMouseWheel (event) {
      const deltaX = event.deltaX
      const $body = this.$refs.body
      if (deltaX > 0) {
        $body.scrollLeft = $body.scrollLeft + 10
      } else {
        $body.scrollLeft = $body.scrollLeft - 10
      }
    },
    showColumn (currentColumn) {
      // 视图模式时
      if (this.editable) {
        if (currentColumn.hasOwnProperty('onEditView')) {
          return currentColumn.onEditView === false
        } else {
          return true
        }
      } else {
        // 编辑模式时
        if (currentColumn.hasOwnProperty('onEditView')) {
          return currentColumn.onEditView === true
        } else {
          return true
        }
      }
    },
    checkSelectedStatus () {
      if (this.supportSpreadPageSelect) {
        for (let i = 0; i < this.insideData.length; i++) {
          let existSelected = this.checkedItems.find(item => item[this.rowIdentifyKey] === this.insideData[i][this.rowIdentifyKey])
          this.checkedIndex[i] = !!existSelected
        }
      }
    },
    checkCanEditable (row, column) {
      if (row.hasOwnProperty('editable')) {
        if (column.hasOwnProperty('editable')) {
          return column.editable
        } else {
          return row.editable
        }
      } else {
        return true
      }
    },
    toggleAllSelect: function () {
      // 改变checkbox 框
      for (let i = 0; i < this.insideData.length; i++) {
        this.checkedIndex[i] = !this.selectAll
      }
      if (!this.supportSpreadPageSelect) {
        // 改变选中的数据
        if (this.selectAll) {
          this.checkedItems = []
        } else {
          this.checkedItems = []
          this.insideData.forEach((row) => {
            this.checkedItems.push(row)
          })
        }
      } else {
        // 取消选中,只取消当前页面选中的
        if (this.selectAll) {
          for (let i = 0; i < this.insideData.length; i++) {
            let selectedObjIndex = this.checkedItems.findIndex(item => item[this.rowIdentifyKey] === this.insideData[i][this.rowIdentifyKey])
            if (selectedObjIndex > -1) {
              this.checkedItems.splice(selectedObjIndex, 1)
            }
          }
        } else {
          // 选中，只能增加当前分页数据全部选中
          for (let i = 0; i < this.insideData.length; i++) {
            let selectedObjIndex = this.checkedItems.findIndex(item => item[this.rowIdentifyKey] === this.insideData[i][this.rowIdentifyKey])
            if (selectedObjIndex === -1) {
              this.checkedItems.splice(i, 0, this.insideData[i])
            }
          }
        }
      }
      this.$emit('on-selection-change', this.checkedItems)
    },
    toggleSelect: function (index) {
      if (!this.supportSpreadPageSelect) {
        if (this.checkedIndex[index]) {
          // 取消选中
          this.checkedItems.splice(index, 1)
        } else {
          // 选中
          this.checkedItems.splice(index, 0, this.insideData[index])
        }
      } else {
        if (this.checkedIndex[index]) {
          // 取消选中
          let selectedObjIndex = this.checkedItems.findIndex(item => item[this.rowIdentifyKey] === this.insideData[index][this.rowIdentifyKey])
          if (selectedObjIndex > -1) {
            this.checkedItems.splice(selectedObjIndex, 1)
          }
        } else {
          // 选中
          this.checkedItems.splice(index, 0, this.insideData[index])
        }
      }
      this.$emit('on-selection-change', this.checkedItems)
    },
    checkHasDataNotPassValidate (changeItems) {
      if (!changeItems && changeItems.length === 0) {
        return true
      } else {
        // 再次验证
        changeItems.forEach(rowItem => {
          this.columns.forEach(columnItem => {
            if (columnItem.onEditView !== false) {
              this.onValidateRule(rowItem, columnItem)
            }
          })
        })
        let result = true
        for (let p in this.cellValidateObj) {
          if (this.cellValidateObj[p] === true) {
            result = false
            break
          }
        }
        return result
      }
    },
    changeViewMode () {
      console.info('changeViewMode-' + new Date().getTime())
      this.changeItems = compareArr(this.rowData, this.insideData)
      // 添加loading 效果
      this.addLoadingStatus()
      setTimeout(() => {
        if (this.editable) {
          this.editable = false
          this.viewText = this.defaultEditSaveText
          this.cancelLoadingStatus()
        } else {
          if (!this.checkHasDataNotPassValidate(this.changeItems)) {
            this.$emit('on-validate-fail', true)
            this.cancelLoadingStatus()
            return
          }
          let callBackResult = this.beforeSaveCallBack(this.changeItems)
          if (Object.prototype.toString.call(callBackResult) === '[object Promise]') {
            // 判断是否是 promise
            callBackResult.then(result => {
              console.info('result===' + result)
              if (result) {
                this.doSaveItems()
              } else {
                this.cancelLoadingStatus()
              }
            })
          } else {
            if (callBackResult === false) {
              this.cancelLoadingStatus()
            } else {
              this.doSaveItems()
            }
          }
        }
      }, 100)
    },
    doSaveItems () {
      if (this.changeItems.length === 0) {
        this.deepCopyTableData()
      }
      let saveResult = this.saveCallBack(this.changeItems)
      if (Object.prototype.toString.call(saveResult) === '[object Promise]') {
        // 如果异步并且保存成功
        saveResult.then(result => {
          if (result !== false) {
            this.saveAndCancelLoading()
          }
        })
      } else {
        // 如果保存成功
        if (saveResult !== false) {
          this.saveAndCancelLoading()
        }
      }
    },
    saveAndCancelLoading () {
      this.addItems = []
      this.editable = true
      this.viewText = this.defaultEditViewText
      this.cancelLoadingStatus()
    },
    addNewItem: function () {
      if (this.editable) {
        this.changeViewMode()
      }
      let { defaultValue } = this
      let newItem = {
        $actionType: 'add',
        $rowKeyIndex: new Date().getTime(),
        state: 1,
        ...defaultValue
      }
      this.addItems.unshift(newItem)
      this.insideData.unshift(newItem)
    },
    deleteInsideItem: function (item) {
      let delItem = item.row
      this.insideData = delArrObject(this.insideData, delItem)
      if (delItem.$actionType === 'update') {
        this.$emit('on-edit-delete', delItem)
      } else if (delItem.$actionType === 'add') {
        this.addItems = delArrObject(this.addItems, delItem)
      }
    },
    deepCopyTableData: function () {
      let copyData = JSON.parse(JSON.stringify(this.rowData))
      if (copyData || this.addItems.length > 0) {
        this.cellValidateObj = {}
        let currentTime = new Date().getTime()
        copyData.forEach((item, index) => {
          item.$actionType = 'update'
          item.$rowKeyIndex = currentTime + index
        })
        this.addItems.forEach((item, index) => {
          item.$actionType = 'add'
          item.$rowKeyIndex = currentTime + index + copyData.length
        })
        this.insideData = [].concat(this.addItems).concat(copyData)
        this.checkSelectedStatus()
      }
    },
    deleteItem () {
      if (this.checkedItems.length > 0) {
        this.$emit('on-batch-delete', this.checkedItems)
        this.checkedItems = []
        this.checkedIndex = []
      } else {
        this.$Message.error('未选中删除的条目')
        this.batchDeleteConfirm = false
      }
    },
    onSearchBtnClick (searchKey) {
      this.searchKey = searchKey
      this.$emit('on-search-click', this.searchKey)
    },
    supportHandle (item) {
      let options = item.options || []
      let insideBtns = []
      options.forEach(item => {
        if (typeof item === 'string') {
          if (handleBtns[item]) insideBtns.push(handleBtns[item])
        } else if (typeof item === 'object') {
          // 增加权限判断
          if (this.defaultBtnPermission(item, 'inside', item.permission)) {
            if (handleBtns[item.name]) insideBtns.push(handleBtns[item.name])
          }
        }
      })
      let addBtn = []
      if (item.button && item.button.length > 0) {
        item.button.forEach(itemBtn => {
          if (typeof itemBtn === 'function') {
            addBtn.push(itemBtn)
          } else if (typeof itemBtn === 'object') {
            if (this.defaultBtnPermission(itemBtn, 'extend', itemBtn.permission)) {
              addBtn.push(itemBtn.render)
            }
          }
        })
      }
      let btns = [].concat(insideBtns, addBtn)
      item.render = (h, params) => {
        params.tableData = this.insideData
        return h('div', btns.map(item => item(h, params, this)))
      }
      // 没有需要渲染的按钮则不显示
      if (btns.length === 0) {
        return false
      }
      return item
    },
    handleColumns (columns) {
      this.insideColumns = []
      columns.forEach((item, index) => {
        let res = item
        if (res.key === 'handle') {
          res = this.supportHandle(res)
        }
        if (res) {
          this.insideColumns.push(res)
        }
      })
    },
    changePage (selectPageIndex) {
      this.currentPage = selectPageIndex
      this.checkedIndex = []
      if (!this.supportSpreadPageSelect) {
        this.checkedItems = []
      }
      this.queryDataCallBack(this.currentPage, this.pageSize)
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize
      let allPage = Math.ceil(this.totalCount / this.pageSize)
      let totalPage = (allPage === 0) ? 1 : allPage
      if (this.currentPage > totalPage) {
        this.currentPage = totalPage
      }
      this.checkedIndex = []
      this.checkedItems = []
      this.queryDataCallBack(this.currentPage, this.pageSize)
    },
    refreshTableState () {
      this.editable = true
      this.viewText = this.defaultEditViewText
      this.searchKey = ''
      this.insideData = []
      this.selectAll = false
      this.checkedIndex = []
      this.checkedItems = []
      this.changeItems = []
      this.addItems = []
      this.pageSize = 20
      this.currentPage = 1
      this.batchDeleteConfirm = false
    },
    onCellContentCopy (copyContent) {
      this.$emit('on-cell-content-copy', copyContent)
    },
    getColumn (index) {
      return this.columns[index]
    },
    handleSort (column, type) {
      // 这里先把排序隐藏掉，然后立即显示出来，页面看不到这个过程，这样做主要是为了是_sortType的值发生变化时，页面重新渲染
      const key = column.key
      column.sortable = false
      let cloneSortColumn = JSON.parse(JSON.stringify(column))
      cloneSortColumn._sortType = type
      // 如果同一个排序列重复点击则默认取消排序
      if (column._sortType === type) {
        column._sortType = 'normal'
      } else {
        column._sortType = type
      }
      this.$emit('on-sort-change', {
        column: cloneSortColumn,
        key: key,
        order: type
      })
      column.sortable = true
    },
    isPopperShow (column) {
      return column.filters
    },
    handleFilterHide (index) {
      console.info('')
      // this.getColumn(index)._filterChecked = []
    },
    handleFilter (index) {
      this.columns[index]._isFiltered = true
      this.columns[index]._filterVisible = false
      this.$emit('on-filter-change', JSON.parse(JSON.stringify(this.columns[index])))
    },
    itemClasses (column, item) {
      return [
        `${this.prefixCls}-filter-select-item`,
        {
          [`${this.prefixCls}-filter-select-item-selected`]: !!column._filterChecked && column._filterChecked[0] === item.value
        }
      ]
    },
    itemAllClasses (column) {
      return [
        `${this.prefixCls}-filter-select-item`,
        {
          [`${this.prefixCls}-filter-select-item-selected`]: !(column._filterChecked && column._filterChecked.length)
        }
      ]
    },
    handleSelect (index, value) {
      this.columns[index]._filterChecked = [value]
      if (this.columns[index].filterRemote) {
        this.columns[index].filterRemote(this.columns[index]._filterChecked, JSON.parse(JSON.stringify(this.columns[index])))
      }
      this.handleFilter(index)
    },
    handleReset (index) {
      this.columns[index]._isFiltered = false
      this.columns[index]._filterVisible = false
      this.columns[index]._filterChecked = []
      this.$emit('on-filter-change', JSON.parse(JSON.stringify(this.columns[index])))
    },
    onContextMenuClick (menuItem) {
      this.$emit('context-menu-click', menuItem)
    },
    forceSaveTempItem () {
      this.addItems = []
      this.viewText = this.defaultEditViewText
      this.addLoadingStatus()
      this.editable = true
      this.cancelLoadingStatus()
    },
    addLoadingStatus () {
      let editTable = document.getElementById(this.editTableName)
      if (editTable) {
        this.coverHeight = editTable.clientHeight
        this.leftCoverMargin = editTable.offsetLeft
        this.topCoverMargin = editTable.offsetTop
      }
      let coverElement = document.getElementById('cover')
      if (coverElement) {
        coverElement.style.height = this.coverHeight + 'px'
        coverElement.style.left = this.leftCoverMargin + 'px'
        coverElement.style.top = this.topCoverMargin + 'px'
        coverElement.style.display = 'block'
      }
    },
    cancelLoadingStatus () {
      let coverElement = document.getElementById('cover')
      this.$nextTick(() => {
        console.info('changeViewMode-finish-' + new Date().getTime())
        if (coverElement) {
          coverElement.style.display = 'none'
          console.info('隐藏模式转换效果')
        }
      })
    }
  },
  watch: {
    rowData: function (val) {
      this.deepCopyTableData()
    },
    columns (columns) {
      this.handleColumns(columns)
    },
    defaultSearchKey (val) {
      this.searchKey = val
    },
    editable (val) {
      this.$emit('on-table-editable-change', val)
    }
  },
  computed: {
    pageCount: function () {
      return this.totalCount / this.pageSize
    }
  },
  mounted: function () {
    // document.oncontextmenu = () => {
    //   return false
    // }
    this.editTableName += new Date().getTime()
    if (this.defaultSearchKey) {
      this.searchKey = this.defaultSearchKey
    }
    this.handleColumns(this.columns)
    // 数组实现深复制
    this.deepCopyTableData(this.rowData, this.insideData)
  }
}
</script>

<style scoped>
  @import url('./edit-table.css');
  .fixed-column-td {
    position: absolute;
    top: 1px;
    left: 1px;
  }
  .error-label {
    border: red;
    border-radius: 2px;
  }
  /*checkbox 样式*/
  label {
    font-size:14px;
    cursor:pointer;
  }
  label i {
    font-size:14px;
    font-style:normal;
    display:inline-block;
    width:14px;
    height:14px;
    text-align:center;
    line-height:14px;
    color:#fff;
    vertical-align:middle;
    margin:-2px 2px 1px 0px;
    border:#2489c5 1px solid;
  }
  input[type="checkbox"] {display:none;}
  input[type="checkbox"]:checked + i,input[type="radio"]:checked + i {background:#2489c5;}
  input[type="checkbox"]:disabled + i,input[type="radio"]:disabled + i {border-color:#ccc;}
  input[type="checkbox"]:checked:disabled + i,input[type="radio"]:checked:disabled + i {background:#ccc;}
  .edit-table-spin-icon-load{
    animation: ani-edit-table-spin 1s linear infinite;
  }
  @keyframes ani-edit-table-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .h-p0 {
    margin: 1px 0px;
    font-size: 14px;
    font-weight: 700;
    line-height: normal;
  }
  .h-p1 {
    margin: 1px 0px;
    font-size: 12px;
    color: #a5a6a9;
    line-height: normal;
  }
  .dxy-table-header-wrapper {
  }
  .dxy-table-body-wrapper {
  }
  .aa {
    display: inline-block;
  }
  .fixed-table-column {
    position: absolute;
    width: 105px;
    right: 0;
    background-color: cadetblue;
    border: 1px solid #fff;
    margin: -1px 0px 0px -1px;
  }
  /*checkbox 样式*/
  .table-body-cell {
    height: 100%;
    padding-left: 2px;
    padding-right: 2px;
  }

  .dw-tooltip-popper {
    position: absolute;
    /*will-change: top, left;*/
    top: 95%;
    left: 0px;
    display: none;
    font-size: 14px;
    line-height: 1.5;
    visibility: visible;
    z-index: 10;
  }
  .dw-tooltip-arrow {
    left: 18px;
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    top: -5px;
    border-width: 0 5px 5px;
    border-bottom-color: rgba(70,76,91,.9);
    z-index: 12
  }
  .dw-tooltip-content {
    text-align: center;
  }
  .dw-tooltip-text {
    max-width: 250px;
    min-height: 34px;
    padding: 8px 12px;
    color: #fff;
    text-align: left;
    text-decoration: none;
    background-color: rgba(70,76,91,.9);
    border-radius: 4px;
    box-shadow: 0 1px 6px rgba(0,0,0,.2);
    word-break: break-all;
    white-space: pre-wrap;
  }
  .dw-tooltip-text:hover .dw-tooltip-popper {
    display: inline-block;
  }
  .table-body-cell:hover .dw-tooltip-popper {
    display: inline-block;
  }

  .change-cover {
    position:absolute;
    background:hsla(0,0%,100%,.9);
    width:100%;  /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
    height:100%;
    filter:alpha(opacity=60);  /*设置透明度为60%*/
    /*opacity:0.6;  !*非IE浏览器下设置透明度为60%*!*/
    display: none;
    z-Index:999;
  }

  .loading4{
    /*width:150px;*/
    margin:50px auto;
    text-align: center;
  }
  .loading4 >div{
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display:inline-block;
    background-color: #67CF22;
    -webkit-animation: three 1.4s infinite ease-in-out;
    animation: three 1.4s infinite ease-in-out;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
  .loading4 .three1{
    -webkit-animation-delay: -0.30s;
    animation-delay: -0.30s;
  }
  .loading4 .three2{
    -webkit-animation-delay: -0.15s;
    animation-delay: -0.15s;
  }
  @-webkit-keyframes three {
    0%, 80%, 100% {-webkit-transform: scale(0.0) }
    40% { -webkit-transform: scale(1.0) }
  }
  @keyframes three {
    0%, 80%, 100% {-webkit-transform: scale(0.0) }
    40% { -webkit-transform: scale(1.0) }
  }
</style>
